import { RestApiDataService } from '@/services/api/RestApiDataService'

const BASE_ENTITY_URL = '/news'

class NewsDataService extends RestApiDataService {

}

export default new NewsDataService(BASE_ENTITY_URL)
